import React from 'react';
import Loader from 'components/Loader';
import Documento from './Documento';
import Itens from './Itens';
import Financeiros from './Financeiros';
import Transportes from './Transportes';
import Registros from './Registros';
import Transmissão from './Transmissão';

const Tabs = ({ tab, getLoading, ...props }) => {
  if (getLoading) {
    return <Loader />;
  }
  switch (tab) {
    case 0:
      return <Documento {...props} />;
    case 1:
      return <Itens {...props} />;
    case 2:
      return <Financeiros {...props} />;
    case 3:
      return <Transportes {...props} />;
    case 4:
      return <Registros {...props} />;
    case 5:
      return <Transmissão {...props} />;
    default:
      return null;
  }
};

export default Tabs;
